import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../api";
import Logo from "../../images/logo-2.png";
import add from "../../images/add.png";
import "react-quill/dist/quill.snow.css";
import {
  Send,
  Mail,
  User,
  Sparkles,
  Loader2,
  Image,
  Paperclip,
  Target,
  Users,
  AtSign,
  FileText,
  Upload,
  CheckCircle,
} from "lucide-react";
import './CustomMail.css';

function CustomMail({}) {
  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [fileName, setFileName] = useState("");

  const handleSubmit = async () => {
    try {
      if (value && subject && email) {
        setLoader(true);

        let template = selectedImg
          ? `
        <div>
          <img src="${selectedImg}" class="img_sel" style="width: 100%;margin-bottom:20px">
          ${value}
        </div>
        `
          : value;

        let payload = {
          template: template,
          subject: subject,
          email: email,
        };

        const userData = await api.sendCustomMail(payload);
        if (userData.success) {
          alert(userData.message);
          setLoader(false);
          setSubject("");
          setEmail("");
          setValue("");
          setSelectedImg("");
          setFileName("");
        } else {
          alert(userData.message || "Something went wrong, email not sent ");
          setLoader(false);
        }
      } else {
        setLoader(false);
        alert("Please insert fields");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong, email not sent ");
    }
  };

  var Editor = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const onFileChange = async (e) => {
    try {
      setLoader(true);
      if (!e.target.files) {
        return;
      }

      const file = e.target.files[0];
      setFileName(file.name);

      const formData = new FormData();
      formData.append("image", file);

      const uploadRes = await api.uploadSingleImg(formData);

      setSelectedImg(
        `${process.env.REACT_APP_S3URL}/img_${uploadRes[0]}.${uploadRes[1]}`
      );
      setLoader(false);
    } catch (e) {
      alert("File upload failed");
      setLoader(false);
      setFileName("");
      console.log(e.message);
    }
  };

  // Stats data
  const [stats, setStats] = useState({
    customEmailsSent: 156,
    averageOpenRate: 68,
    recipients: 1,
    attachmentRate: 42,
  });

  useEffect(() => {
    // You can fetch actual stats here
    setStats({
      customEmailsSent: 1567,
      averageOpenRate: 78,
      recipients: 234,
      attachmentRate: 65,
    });
  }, []);

  return (
    <>

      <div className="custom-email-dashboard">
        {/* Header with integrated stats */}
        <div className="custom-dashboard-header-container">
          <div className="custom-header-main">
            <div className="custom-header-icon">
              <Target size={22} />
            </div>
            <div className="custom-header-content">
              <h1>Send Custom Mail To User</h1>
              <p>Send personalized emails to specific recipients</p>
            </div>
          </div>

          {/* Stats Grid */}
          {/* <div className="custom-stats-grid">
            <div className="custom-stat-card">
              <div className="custom-stat-icon custom-stat-icon-1">
                <Send size={24} />
              </div>
              <div className="custom-stat-info">
                <h3>{stats.customEmailsSent.toLocaleString()}</h3>
                <p>CUSTOM EMAILS SENT</p>
              </div>
            </div>

            <div className="custom-stat-card">
              <div className="custom-stat-icon custom-stat-icon-2">
                <AtSign size={24} />
              </div>
              <div className="custom-stat-info">
                <h3>{stats.averageOpenRate}%</h3>
                <p>AVERAGE OPEN RATE</p>
              </div>
            </div>

            <div className="custom-stat-card">
              <div className="custom-stat-icon custom-stat-icon-3">
                <User size={24} />
              </div>
              <div className="custom-stat-info">
                <h3>{stats.recipients.toLocaleString()}</h3>
                <p>RECIPIENTS TODAY</p>
              </div>
            </div>

            <div className="custom-stat-card">
              <div className="custom-stat-icon custom-stat-icon-4">
                <Paperclip size={24} />
              </div>
              <div className="custom-stat-info">
                <h3>{stats.attachmentRate}%</h3>
                <p>WITH ATTACHMENTS</p>
              </div>
            </div>
          </div> */}
        </div>

        {/* Email Form Card */}
        <div className="custom-email-card">
          <div className="custom-card-header">
            <div className="custom-card-icon">
              <Mail size={20} />
            </div>
            <h2>Compose Personalized Email</h2>
          </div>

          <div className="custom-form-group">
            <label>
              <AtSign size={16} />
              Recipient Email
            </label>
            <input
              type="email"
              className="custom-form-control"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email..."
              value={email}
            />
          </div>

          <div className="custom-form-group">
            <label>
              <FileText size={16} />
              Email Subject
            </label>
            <input
              type="text"
              className="custom-form-control"
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Subject..."
              value={subject}
            />
          </div>

          <div className="custom-form-group">
            <label>
              <Sparkles size={16} />
              Email Content
            </label>
            <div className="custom-editor-container">
              <ReactQuill
                placeholder="Add Email description"
                modules={Editor}
                theme="snow"
                value={value}
                onChange={setValue}
              />
            </div>
          </div>

          {/* File Upload Section */}
          <div className="custom-file-upload-container">
            <label className="custom-file-upload-label">
              <Image size={16} />
              Add Image Attachment (Optional)
            </label>

            <div
              className={`custom-file-upload-box ${
                selectedImg || fileName ? "has-file" : ""
              }`}
            >
              <input
                name="file"
                onChange={onFileChange}
                accept="image/*"
                type="file"
                className="custom-file-upload-input"
              />

              {selectedImg || fileName ? (
                <>
                  <div className="custom-file-info">
                    <div className="custom-file-icon">
                      <CheckCircle size={20} />
                    </div>
                    <div className="custom-file-details">
                      <div className="custom-file-name">
                        <CheckCircle size={14} />
                        {fileName || "Image uploaded"}
                      </div>
                      <p className="custom-file-size">Click to change image</p>
                    </div>
                  </div>

                  {selectedImg && (
                    <div className="custom-preview-image">
                      <img src={selectedImg} alt="Preview" />
                    </div>
                  )}
                </>
              ) : (
                <div className="custom-upload-content">
                  <div className="custom-upload-icon">
                    <Upload size={24} />
                  </div>
                  <div className="custom-upload-text">
                    <h4>Upload Image</h4>
                    <p>Click or drag to upload image file</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="custom-button-group">
            <button onClick={handleSubmit} className="custom-btn custom-btn-primary">
              <Send size={18} />
              Send Custom Mail
            </button>
          </div>
        </div>

        {/* Loader */}
        {loader && (
          <div className="custom-loader-overlay">
            <div className="custom-loader-content">
              <Loader2 size={48} className="custom-loader-spinner" />
              <p className="custom-loader-text">Sending custom email...</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CustomMail;